<template>
  <div class="container">
    <div class="container left">

      <div class="row" style="padding-left: 15px;">      
        <div class="col-sm-1">
          <div class="dropdown" style="position:fixed;left:0;top:0;padding:0;margin-top:0;margin-bottom:0">
            <ReportsMenu/>
          </div>          
        </div>
        <div class="col-sm-12">        
          <br>  
          <br>  
        <div class="col-sm-1" style="text-align:right;color: white;padding-left: 0px;">
          <table>
            <tr>
              <td><label title="User" style="font-size:1.2em">User:</label></td>
              <td><input type="checkbox"  @click="handleAll()" id="select_all" style="font-size:1.5em"> </td>
            </tr>
          </table>
        </div>
        <div class="col-sm-3" style="text-align:right;font-size:1.3em;">
          <select id="paid_by" v-model="paid_by" name="paid_by"  style="color:black;font-size:1.3em">
            <option value="0">Select a cashier</option>
          </select>                  
        </div>
          <div class="col-sm-1" style="text-align:right">
            <label title="Date" style="font-size:1.5em;color: white">Date:</label>
          </div>
          <div >
            <div class="col-sm-3" style="text-align:right">
              <datepicker v-model="state.date" 
                name="selected_date"
                format="yyyy-MM-dd"
                @selected="parentfunctionSelectedhandler" 
                @opened="datepickerOpenedFunction" 
                @closed="parentfunctionCloseHandler"></datepicker>
        </div>
        </div>
        <div class="col-sm-1" style="text-align:right">
            <label title="Date" style="font-size:1.5em;color: white">Invoice:</label>
        </div>
        <div class="col-sm-2" style="text-align:right">
            <input type="text" class="form-control" name="orderId" v-model="orderId">
        </div>
        <div class="col-sm-1" style="text-align:right">
            <button class="btn btn-success" style="font-size:1.5em" @click="findCashierPayment()">Find</button>  
        </div>


        </div>          
      </div>    

        <br>

 
      <div v-if="toggle">
        <div v-if="!checkNoResults()" style="text-align:right">
            <button class="btn btn-success" style="font-size:1.5em" @click="printReport()">Print</button>  
        </div>
        <div v-if="checkNoResults()" style="text-align:center">
          <div v-if="select_all" style="font-size:2em;text-align: center;background-color: #999999;">No Data Found</div>    
        </div>


      <div v-if="checkTotalSales()" class="row table-wrap" style="color: #fff; ">
          <div v-if="select_all" style="font-size:2em;text-align: center;background-color: #999999;">Total Sales Of {{user_name}} On {{dateToYMD(this.state.date)}}</div>
          <div v-if="!select_all"  style="font-size:2em;text-align: center;background-color: #999999;">Total Sales On {{dateToYMD(this.state.date)}}</div>
          <table class="table"  style="color: #fff;">
            <thead>
              <tr>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in total_sales" :key="item.userId">
                <td style="font-size:1.5em;text-align: right;">{{totalSalesAmount}}</td>
              </tr>
            </tbody>
          </table>
          <hr/>
      </div>
<br>
      <div v-if="checkPaymentTotals()" class="row table-wrap" style="color: #fff; ">
          <div v-if="select_all" style="font-size:2em;text-align: center;background-color: #999999;">Total Payments Of {{user_name}} On {{dateToYMD(this.state.date)}}</div>
          <div v-if="!select_all"  style="font-size:2em;text-align: center;background-color: #999999;">Total Payments On {{dateToYMD(this.state.date)}}</div>

          <table class="table"  style="color: #fff;">
            <thead>
              <tr>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">Payment Type</th>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in payment_totals" :key="item.userId">
                <td style="font-size:1.5em;text-align: right;">{{item.paymentType}}</td>
                <td style="font-size:1.5em;text-align: right;">{{formatNumber(item.total_amount)}}</td>
              </tr>
              <tr>
                <td style="font-size:1.5em;text-align: right;background-color: black;"><h3>Total</h3></td>
                <td style="font-size:1.5em;text-align: right;background-color: black;"><h3>{{payment_total_amount}}</h3></td>
              </tr>
            </tbody>
          </table>
          <hr/>
      </div>
<br>

      <div v-if="checkCustomerpayments()" class="row table-wrap" style="color: #fff; ">
        <div v-if="select_all" style="font-size:2em;text-align: center;background-color: #999999;">Customers Payments Of {{user_name}} On {{dateToYMD(this.state.date)}}</div>
          <div v-if="!select_all"  style="font-size:2em;text-align: center;background-color: #999999;">Customers Payments On {{dateToYMD(this.state.date)}}</div>
          <table class="table"  style="color: #fff;">
            <thead>
              <tr>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">Name</th>
                <th  style="font-size:1.5em;text-align: right;background-color: black;">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in customer_payments" :key="item.userId">
                <td style="font-size:1.5em;text-align: right;">{{item.name}}</td>
                <td style="font-size:1.5em;text-align: right;">{{item.total_amount}}</td>
              </tr>
              <tr>
                <td style="font-size:1.5em;text-align: right; background-color: black;"><h3>Total</h3></td>
                <td style="font-size:1.5em;text-align: right; background-color: black;"><h3>{{customer_payments_amount}}</h3></td>
              </tr>
            </tbody>
          </table>
          <hr/>
      </div>
      </div>

    </div>
  </div>
</template>

<script>
  import numericpad from "@/components/SimpleKeyboard";
  import { useRoute } from 'vue-router'
  import { ref } from "vue"
  import axios from "axios";
  import router from '@/router';
  import commonServices from "@/shared/commonServices"
  import ReportsMenu from "@/components/ReportsMenu";
  //import DatePick from 'vue-date-pick';
  import Datepicker from 'vuejs3-datepicker';
  import 'vue-date-pick/dist/vueDatePick.css';
export default {
    mixins: [commonServices],
    mounted() {
      this.$el.querySelector('#paid_by').disabled = true;

      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth();
      let day = nowDate.getDate();
      this.state.date = new Date(year+'', month+'',  day+'');
      this.orderDate = this.state.date;
      this.getUsers();
      
      this.getCurrentDateTime();
      if(localStorage.userId===undefined){
        //this.$router.push({ name: 'login'});
      }
      this.language = 'ar';
      this.handleLanguage();
      this.getLogo();
      if(localStorage.reports_ok === "1"){
        this.reports_ok = true;
      }
      this.logoImage = '<img src="'+this.logoUrl+'" width="70" height="50" alt="Logo">';
    },    
    components:{ ReportsMenu, Datepicker },
    data: function(){
        return {
          state: {date: new Date(2016, 9,  16)},
          users: [],
          usersJson: {},
          reports_ok: false,
          select_all: false,
          dailySales: [],
          showError: false,
          logoImage: '',
          total_sales: [],
          payment_totals: [],
          customer_payments: [],
          userSalesPaymentJson: {},
          mainErrorMsg: '',
          logoUrl:'',
          user_name: '',
          payment_total_amount:"",
          customer_payments_amount:"",
          totalSalesAmount: "",
          jsonData: {},
          language: 'en',
          languageName: '',
          toggle: false,
          orderDate:'',
          paid_by:0,
          orderId:0,
        }
    },
    methods:{
    parentfunctionSelectedhandler() {
      this.total_sales = [];
                this.payment_totals = [];
                this.customer_payments = [];

    },
    datepickerOpenedFunction() {
    },
    parentfunctionCloseHandler() {
    },
      addOption (selectbox, value, text) {
          var optn = document.createElement("OPTION");
          optn.text = text;
          optn.value = value;
          selectbox.options.add(optn);  
      },      

  handleReports() {
      this.$router.push({ name: 'reports'} );
    },
    checkCustomerpayments(){
      let showResults = false;
      if(this.customer_payments.length > 0){
        showResults = true;
      }
      return showResults;
    },    
    checkPaymentTotals(){
      let showResults = false;
      if(this.payment_totals.length > 0){
        showResults = true;
      }
      return showResults;
    },    
    checkTotalSales(){
      let showResults = false;
      if(this.total_sales.length > 0){
        showResults = true;
      }
      return showResults;
    },    
    checkNoResults(){
      let showResults = false;
      if(this.total_sales.length == 0 && this.payment_totals.length == 0 && this.customer_payments.length == 0){
        showResults = true;
      }
      return showResults;
    },    

    handleAll(){
      this.total_sales = [];
      this.payment_totals = [];
      this.customer_payments = [];
      if(this.select_all){
        this.select_all = false;
        this.$el.querySelector('#paid_by').disabled = true;
      }else{
        this.select_all = true;
        this.$el.querySelector('#paid_by').disabled = false;
      }
    },
  handleMainPage() {
      this.$router.push({ name: 'main'} );
    },

      
  getCurrentDateTime(){
    let dateTimeStr = '';
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      var today = new Date();
      this.orderDate = year+'-'+month+'-'+day;
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      dateTimeStr = year+'-'+month+'-'+day+' '+time;
    return dateTimeStr;
  },

  findCashierPayment: async function(){
      this.orderDate = this.state.date;

      this.userSalesPaymentJson.appId = localStorage.appId;
      this.userSalesPaymentJson.orderDate = this.dateToYMD(this.state.date);
      if(this.orderId !== 0){
        this.userSalesPaymentJson.orderId = this.orderId;
      }
      if(this.paid_by !== 0){
        this.userSalesPaymentJson.paid_by = this.paid_by;
      }
      try{
          let dataURL = this.apiURL+'GiftCard/findCashierPayment';
          let response = await axios.post(dataURL, this.userSalesPaymentJson);  
          if(response.data.status === 'success'){
              this.toggle = true;
                this.payments = response.data.results.payments;
                this.payment_totals = response.data.results.total_amount;
          }
      }
      catch (error){
          console.log(error);
      }
    },   
formatNumber(nStr)
{
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
},

    printReport (){
      const nowDate = new Date();
      let year = nowDate.getFullYear();
      let month = nowDate.getMonth()+1;
      let day = nowDate.getDate();
      var today = new Date();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      let reportHeader = "Daily Sales Report";
      let reportFooter = "Printed on: "+year+"-"+month+"-"+day+ " "+time;
      this.printUserSalesPaymentReport(this.totalSalesAmount, this.payment_totals, this.customer_payments, reportHeader, 
      reportFooter, this.dateToYMD(this.orderDate), this.payment_total_amount, this.customer_payments_amount)      
    },
        printUserSalesPaymentReport(totalSalesAmount, reportData2, reportData3, reportHeader, reportFooter, reportDate, payment_total_amount, customer_payments_amount){
    
          let viaInvStr = '<table width="100%">';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<table align="center" width="25%"  style="border-bottom: #000000 2px solid; vertical-align:bottom"><tr><td width="100%" align="center" style="vertical-align:bottom"><b><p style="font-size:1.5em">'+reportHeader+'</p></b></td></tr></table>'; 
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<table align="left" width="25%"  style="border-bottom: #000000 2px solid;"><tr><td width="50%" align="left" ><b><p style="font-size:1.5em">Date:</p></b></td><td width="50%" align="left"><b><p style="font-size:1.5em">'+reportDate+ '</p></b></td></tr></table>';
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          //if(reportData1.length >0){
            viaInvStr = viaInvStr + '<table align="left" width="50%" style="border-bottom: #000000 2px solid;"><tr><td align="left"><b><p style="font-size:1.5em">Total Sales:</p></b></td><td align="right"><b><p style="font-size:1.5em">'+totalSalesAmount+ '</p></b></td></tr></table>';
            //viaInvStr = viaInvStr + '<table align="center" width="100%"><tr><td width="100%" align="center"><p style="font-size:2em"></p></td></tr></table>';
          //}
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<table align="left" width="50%" style="border-bottom: #000000 2px solid;"><tr><td align="left"><b><p style="font-size:1.5em">Collected As</p></b></td><td align="right"><b><p style="font-size:1.5em">Amount</p></b></td></tr></table>';
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          //viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
          reportData2.forEach(function(item) {
            viaInvStr = viaInvStr + '<table align="left" width="50%"><tr><td align="left"><p style="font-size:1.5em">'+item.paymentType+'</p></td><td align="right"><p style="font-size:1.5em">'+item.total_amount+'</p></td></tr></table>';
            viaInvStr = viaInvStr + '</td></tr>';
            viaInvStr = viaInvStr + '<tr><td>';
          });        
          viaInvStr = viaInvStr + '</td></tr>';

          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<table align="left" width="50%" style="border-top: #000000 2px solid;"><tr><td align="left"><b><p style="font-size:1.5em">Total Collected</p></b></td><td align="right"><b><p style="font-size:1.5em">'+payment_total_amount+'</p></b></td></tr></table>';
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          //viaInvStr = viaInvStr + '<table align="left" width="25%" style="border-bottom: #000000 2px solid;"><tr><td align="left" width="100%" style="border-bottom:2px"><b><p style="font-size:1.5em">On Account </p></b></td></tr></table>';
          viaInvStr = viaInvStr + '<table align="left" width="50%" style="border-bottom: #000000 2px solid;"><tr><td align="left"><b><p style="font-size:1.5em">On Account</p></b></td><td align="right"><b><p style="font-size:1.5em"></p></b></td></tr></table>';
          viaInvStr = viaInvStr + '</td></tr>';


          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<table align="left" width="50%" style="border-bottom: #000000 2px solid;"><tr><td align="left"><b><p style="font-size:1.5em">Name</p></b></td><td align="right"><b><p style="font-size:1.5em">Amount</p></b></td></tr></table>';
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          //viaInvStr = viaInvStr + '<tr><td width="100%" align="center" colspan="6"><hr></td></tr>';
          reportData3.forEach(function(item) {
            viaInvStr = viaInvStr + '<table align="left" width="50%"><tr><td align="left"><p style="font-size:1.5em">'+item.name+'</p></td><td align="right"><p style="font-size:1.5em">'+item.total_amount+'</p></td></tr></table>';
            viaInvStr = viaInvStr + '</td></tr>';
            viaInvStr = viaInvStr + '<tr><td>';
          });        
          viaInvStr = viaInvStr + '</td></tr>';
          viaInvStr = viaInvStr + '<tr><td>';
          viaInvStr = viaInvStr + '<table align="left" width="50%" style="border-top: #000000 2px solid;"><tr><td align="left"><b><p style="font-size:1.5em">Total</p></b></td><td align="right"><b><p style="font-size:1.5em">'+customer_payments_amount+'</p></b></td></tr></table>';
          viaInvStr = viaInvStr + '</td></tr>';

          viaInvStr = viaInvStr + '</table>';
          this.sharedPrintElemmRep(viaInvStr);

      },

      getUsers: async function(){
      this.usersJson.appId = localStorage.appId;
      let usersJson_ = JSON.stringify(this.usersJson);
      try{
          let dataURL = this.apiURL+'GiftCard/getPosUsers';
          let response = await axios.post(dataURL, usersJson_);  
          if(response.data.status === 'success'){
            this.users = response.data.results;
            console.log("this.users", this.users)
            var dropdown = document.getElementById("paid_by");
            if (dropdown) {
                for (var i=0; i < this.users.length;++i){    
                    this.addOption(dropdown, this.users[i].id, this.users[i].partOne);
                }
            }


          }
      }
      catch (error){
          console.log(error);
      }
    },   
    getCustomerAddresses: async function(customerid){
      //let customersJson = {};      
      this.customersJson.appId = localStorage.appId;
      //this.customersJson.appId = "7";           
      this.customersJson.customerid = customerid;
      let customersJson_ = JSON.stringify(this.customersJson);
      try{
          
          let dataURL = this.apiURL+'Customers/getCustomerAddresses';

          let response = await axios.post(dataURL, customersJson_);  
          if(response.data.status === 'success'){
            this.customerAddresses = response.data.results.customersAddresses;
          this.addressid = this.customerAddresses[0].id;
          this.addressLine1 = this.customerAddresses[0].line;
          this.addressLine2 = this.customerAddresses[0].line1;
          this.addressArea = this.customerAddresses[0].area;
          this.addressCity = this.customerAddresses[0].city;
          this.isDefault = this.customerAddresses[0].is_default;

            this.showAddress = true;
          }else{
            this.showAddress = true;
            this.customerAddresses = [];
          }
      }
      catch (error){
          console.log(error);
      }
    },   

   goLogin()
    {
      this.$router.push({ name: 'login', query: { redirect: '/login' } });
    },

  fixNumber(num)
    {
      let mum2 = parseFloat(Math.round(num)).toFixed(2);
      return mum2;
    },
    getImgUrl(){
      let logoUrlStr;
      logoUrlStr = this.logoUrl;
      return logoUrlStr;
    },
    getLogo: async function(){
        try{            
            let dataURL = this.apiURL+'Orders/getInvoiceLogo';
            let logoJson = {"appId": localStorage.appId};
            let response = await axios.post(dataURL, logoJson); 
            if(response.data.status === 'success'){
                this.logoUrl=response.data.results.logourl;
            }
        }
        catch (error){
            console.log(error);
        }
      },    
    }
  }
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 20px;
}

.glyphicon.glyphicon-ok {
    font-size: 30px;
}

.button {
  font: bold 15px Arial;
  text-decoration: none;
  background-color: #EEEEEE;
  color: #333333;
  /* padding: 2px 6px 2px 6px;
  border-top: 1px solid #CCCCCC;
  border-right: 1px solid #333333;
  border-bottom: 1px solid #333333;
  border-left: 1px solid #CCCCCC; */
}
.grid-container-element { 
    display: grid; 
    grid-template-columns: 5fr 1.5fr 1.5fr 1.5fr 0.5fr; 
    grid-gap: 10px; 
    border: 1px solid whitesmoke; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    width: 100%; 
} 
.grid-child-element_ { 
    margin: 10px; 
    border: 1px solid red; 
}
.grid-child-element { 
    margin: 2px; 
    border-left : 0px; 
    border-right : 0px; 
    border-top : 0px; 
    padding : 0 px;
    
}

</style>